export const CREATE_TEAM_API = "CREATE_TEAM_API";
export const EDIT_TEAM_API = "EDIT_TEAM_API";
export const SAVE_TEAM_LIST = "SAVE_TEAM_LIST";
export const GET_TEAM_LIST = "GET_TEAM_LIST";
export const DELETE_TEAM_API = "DELETE_TEAM_API";
export const DELETE_MANY_TEAM_API = "DELETE_MANY_TEAM_API";
export const BLOCK_MULTIPLE_TEAM_API = "BLOCK_MULTIPLE_TEAM_API";
export const GET_ALL_TEAM_LIST = "GET_ALL_TEAM_LIST";